/** Ключ localStorage для клиентских настроек UI (страница «Настройки»). */
export const USER_SETTINGS_STORAGE_KEY = "geopulse:user-settings";

export type UiTheme = "light" | "dark" | "system";

/** Читает сохранённую тему из JSON настроек; источник истины для согласования с next-themes. */
export function readThemeFromUserSettings(): UiTheme {
  if (typeof window === "undefined") return "system";
  try {
    const raw = localStorage.getItem(USER_SETTINGS_STORAGE_KEY);
    if (!raw) return "system";
    const parsed = JSON.parse(raw) as { theme?: string };
    const t = parsed.theme;
    if (t === "light" || t === "dark" || t === "system") return t;
  } catch {
    /* ignore */
  }
  return "system";
}
